import React from 'react';
import * as cn from 'classnames';
import PropTypes from 'prop-types';

import './Splash.scss';

function Splash({ className, ...props }) {
  return (
    <div
      className={cn('wrapper-loader', { [className]: !!className })}
      {...props}
    >
      <div style={{ width: '100%', maxWidth: '250px' }}>
        <svg
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          enableBackground="new 0 0 100 100"
        >
          <circle
            fill="none"
            stroke="#fff"
            strokeWidth="6"
            strokeDasharray="14.2472,14.2472,1"
            cx="50"
            cy="50"
            r="47"
          >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="10s"
              from="0 50 50"
              to="360 50 50"
              repeatCount="indefinite"
            />
          </circle>
          <circle
            fill="none"
            stroke="#fff"
            strokeWidth="1"
            strokeMiterlimit="10"
            strokeDasharray="11,11"
            cx="50"
            cy="50"
            r="39"
          >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="5s"
              from="0 50 50"
              to="-360 50 50"
              repeatCount="indefinite"
            />
          </circle>
          <svg stroke="#fff" strokeWidth="1" className="text-line">
            <text
              x="50"
              y="50"
              fontSize="40"
              fill="none"
              style={{ fontWeight: '700' }}
            >
              DP
            </text>
          </svg>
        </svg>
      </div>
    </div>
  );
}

Splash.defaultProps = {
  className: '',
};

Splash.propTypes = {
  className: PropTypes.string,
};

export default React.memo(Splash);
